import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: ${theme.shapes.borderRadius.sm};
  background-color: ${theme.colors.neutral['100']};
`
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${theme.spacing.xm};
  padding: 81px 200px;

  @media (max-width: ${theme.breakpoints.lg}px) {
    padding: 81px 50px;
  }
`

export const Title = styled.h5`
  margin: 0;
  font-family: ${theme.typography.family.bold};
  font-size: ${theme.typography.sizes['2md']};
  font-weight: ${theme.typography.weight.lg};
  color: ${theme.colors.neutral.high};
`

export const Text = styled.span`
  font-size: ${theme.typography.sizes.sm};
  color: ${theme.colors.neutral.high};
  text-align: center;
`
